import React from 'react';

const SLLogo = ({ width = 32, height = 32 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer circle */}
    <circle cx="12" cy="12" r="11" fill="#4a6fa5" />
    <circle cx="12" cy="12" r="10" fill="#ffffff" />
    
    {/* Stylized "O" for Orion */}
    <path 
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12"
      stroke="#4a6fa5" 
      strokeWidth="2.5" 
      strokeLinecap="round"
    />
    
    {/* Inner spiral element */}
    <path 
      d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16"
      stroke="#4a6fa5" 
      strokeWidth="2.5" 
      strokeLinecap="round"
    />
  </svg>
);

export default SLLogo;
